import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AuditPage from "@/pages/AuditPage";
import ReportPage from "@/pages/ReportPage";
import LeadsPage from "@/pages/LeadsPage";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AuditPage />} />
          <Route path="/r/:id" element={<ReportPage />} />
          <Route path="/leads" element={<LeadsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;
